enum Roles {
    none = 0,
    user = 1,
    admin = 2,
    superAdmin =3
}

export default Roles;